import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { EnumToUiOption } from '../models/enum-to-ui.model';

export enum SSOProviderEnum {
    Facebook = 1,
    Twitter = 2,
    Google = 3,
    Apple = 4,
    AzureAd = 5,
    Email = 1000,
}

export enum OnboardingStatusEnum {
    ProfileSetup = 1,
    CompanySetup = 2,
    Completed = 3,
}

export enum CompanyIndustryEnum {
    BuildingMaterials = 1,
    Carpentry = 2,
    Chemical = 3,
    CleaningServices = 4,
    Construction = 5,
    Consultancy = 6,
    Contractor = 7,
    DepartmentStore = 8,
    DesignAndManufacture = 9,
    Distributor = 10,
    Electrical = 11,
    Engineering = 12,
    EScooterEBikeBicycle = 13,
    Financing = 14,
    FoodAndBeverage = 15,
    FreightForwarder = 16,
    Government = 17,
    Hardware = 18,
    Hospital = 19,
    ImporterAndExporter = 20,
    InformationTechnology = 21,
    ITEPolytechnicUniversity = 22,
    Logistic = 23,
    Manufacturing = 24,
    Marine = 25,
    MedicalAndPharmaceutical = 26,
    MfgAndRepairOfLiftingEqpt = 27,
    Monastery = 28,
    NewaterToPUB = 29,
    OilAndGas = 30,
    OtherIndustries = 31,
    Packaging = 32,
    Paints = 33,
    Petroleum = 34,
    Printing = 35,
    Racking = 36,
    Recycling = 37,
    Rental = 38,
    RetailSales = 39,
    Scaffolding = 40,
    Security = 41,
    Service = 42,
    ShippingStevedoring = 43,
    Societies = 44,
    Trading = 45,
    WarehousingTransportation = 46,
    WholesaleAndRetail = 47,
    WoodTimber = 48,
}

export enum DeviceTypeEnum {
    None = 0,
    IOS = 1,
    Android = 2,
    Web = 3,
    HuaWei = 4,
}

export const SSO_PROVIDER_OPTIONS = new Map<SSOProviderEnum, EnumToUiOption>([
    [SSOProviderEnum.Facebook, { label: _('Facebook'), cssClass: 'facebook' }],
    [SSOProviderEnum.Twitter, { label: _('Twitter'), cssClass: 'twitter' }],
    [SSOProviderEnum.Google, { label: _('Google'), cssClass: 'google' }],
    [SSOProviderEnum.Apple, { label: _('Apple'), cssClass: 'apple' }],
    [SSOProviderEnum.AzureAd, { label: _('Azure AD'), cssClass: 'azure-ad' }],
    [SSOProviderEnum.Email, { label: _('Email'), cssClass: 'email' }],
]);

export const COMPANY_INDUSTRY_OPTIONS = new Map<CompanyIndustryEnum, EnumToUiOption>([
    [CompanyIndustryEnum.BuildingMaterials, { label: _('Building Materials'), cssClass: '' }],
    [CompanyIndustryEnum.Carpentry, { label: _('Carpentry'), cssClass: '' }],
    [CompanyIndustryEnum.Chemical, { label: _('Chemical'), cssClass: '' }],
    [CompanyIndustryEnum.CleaningServices, { label: _('Cleaning Services'), cssClass: '' }],
    [CompanyIndustryEnum.Construction, { label: _('Construction'), cssClass: '' }],
    [CompanyIndustryEnum.Consultancy, { label: _('Consultancy'), cssClass: '' }],
    [CompanyIndustryEnum.Contractor, { label: _('Contractor'), cssClass: '' }],
    [CompanyIndustryEnum.DepartmentStore, { label: _('Department Store'), cssClass: '' }],
    [CompanyIndustryEnum.DesignAndManufacture, { label: _('Design and Manufacture'), cssClass: '' }],
    [CompanyIndustryEnum.Distributor, { label: _('Distributor'), cssClass: '' }],
    [CompanyIndustryEnum.Electrical, { label: _('Electrical'), cssClass: '' }],
    [CompanyIndustryEnum.Engineering, { label: _('Engineering'), cssClass: '' }],
    [CompanyIndustryEnum.EScooterEBikeBicycle, { label: _('E-Scooter / E-Bike / Bicycle'), cssClass: '' }],
    [CompanyIndustryEnum.Financing, { label: _('Financing'), cssClass: '' }],
    [CompanyIndustryEnum.FoodAndBeverage, { label: _('Food and Beverage'), cssClass: '' }],
    [CompanyIndustryEnum.FreightForwarder, { label: _('Freight Forwarder'), cssClass: '' }],
    [CompanyIndustryEnum.Government, { label: _('Government'), cssClass: '' }],
    [CompanyIndustryEnum.Hardware, { label: _('Hardware'), cssClass: '' }],
    [CompanyIndustryEnum.Hospital, { label: _('Hospital'), cssClass: '' }],
    [CompanyIndustryEnum.ImporterAndExporter, { label: _('Importer and Exporter'), cssClass: '' }],
    [CompanyIndustryEnum.InformationTechnology, { label: _('Information Technology'), cssClass: '' }],
    [CompanyIndustryEnum.ITEPolytechnicUniversity, { label: _('ITE / Polytechnic / University'), cssClass: '' }],
    [CompanyIndustryEnum.Logistic, { label: _('Logistic'), cssClass: '' }],
    [CompanyIndustryEnum.Manufacturing, { label: _('Manufacturing'), cssClass: '' }],
    [CompanyIndustryEnum.Marine, { label: _('Marine'), cssClass: '' }],
    [CompanyIndustryEnum.MedicalAndPharmaceutical, { label: _('Medical and Pharmaceutical'), cssClass: '' }],
    [
        CompanyIndustryEnum.MfgAndRepairOfLiftingEqpt,
        { label: _('Manufacturing and Repair of Lifting Equipment'), cssClass: '' },
    ],
    [CompanyIndustryEnum.Monastery, { label: _('Monastery'), cssClass: '' }],
    [CompanyIndustryEnum.NewaterToPUB, { label: _('NEWater to PUB'), cssClass: '' }],
    [CompanyIndustryEnum.OilAndGas, { label: _('Oil and Gas'), cssClass: '' }],
    [CompanyIndustryEnum.OtherIndustries, { label: _('Other Industries'), cssClass: '' }],
    [CompanyIndustryEnum.Packaging, { label: _('Packaging'), cssClass: '' }],
    [CompanyIndustryEnum.Paints, { label: _('Paints'), cssClass: '' }],
    [CompanyIndustryEnum.Petroleum, { label: _('Petroleum'), cssClass: '' }],
    [CompanyIndustryEnum.Printing, { label: _('Printing'), cssClass: '' }],
    [CompanyIndustryEnum.Racking, { label: _('Racking'), cssClass: '' }],
    [CompanyIndustryEnum.Recycling, { label: _('Recycling'), cssClass: '' }],
    [CompanyIndustryEnum.Rental, { label: _('Rental'), cssClass: '' }],
    [CompanyIndustryEnum.RetailSales, { label: _('Retail Sales'), cssClass: '' }],
    [CompanyIndustryEnum.Scaffolding, { label: _('Scaffolding'), cssClass: '' }],
    [CompanyIndustryEnum.Security, { label: _('Security'), cssClass: '' }],
    [CompanyIndustryEnum.Service, { label: _('Service'), cssClass: '' }],
    [CompanyIndustryEnum.ShippingStevedoring, { label: _('Shipping & Stevedoring'), cssClass: '' }],
    [CompanyIndustryEnum.Societies, { label: _('Societies'), cssClass: '' }],
    [CompanyIndustryEnum.Trading, { label: _('Trading'), cssClass: '' }],
    [CompanyIndustryEnum.WarehousingTransportation, { label: _('Warehousing & Transportation'), cssClass: '' }],
    [CompanyIndustryEnum.WholesaleAndRetail, { label: _('Wholesale and Retail'), cssClass: '' }],
    [CompanyIndustryEnum.WoodTimber, { label: _('Wood / Timber'), cssClass: '' }],
]);

export function getSSOProviderOption(provider: SSOProviderEnum): EnumToUiOption {
    const foundOption = SSO_PROVIDER_OPTIONS.get(provider);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}

export function getCompanyIndustryOption(industry: CompanyIndustryEnum): EnumToUiOption {
    const foundOption = COMPANY_INDUSTRY_OPTIONS.get(industry);

    if (!foundOption) {
        return new EnumToUiOption();
    }

    return foundOption;
}
